/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PoolStatusResponse
 */
export interface PoolStatusResponse {
  /**
   *
   * @type {string}
   * @memberof PoolStatusResponse
   */
  type?: PoolStatusResponseTypeEnum
  /**
   * List of identified validation issues in a user-friendly format
   * @type {Array<string>}
   * @memberof PoolStatusResponse
   */
  notes?: Array<string>
}

/**
 * @export
 * @enum {string}
 */
export enum PoolStatusResponseTypeEnum {
  OFF = 'OFF',
  USER_STAKED = 'USER_STAKED',
  HIDDEN = 'HIDDEN',
}

export function PoolStatusResponseFromJSON(json: any): PoolStatusResponse {
  return PoolStatusResponseFromJSONTyped(json, false)
}

export function PoolStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoolStatusResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    type: !exists(json, 'type') ? undefined : json['type'],
    notes: !exists(json, 'notes') ? undefined : json['notes'],
  }
}

export function PoolStatusResponseToJSON(value?: PoolStatusResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    type: value.type,
    notes: value.notes,
  }
}
